import { Analytics } from '../helpers/analytics';
import { EventEmitter } from './event-emitter';
import { ElementHelpers } from '../helpers/element-helpers';
import { Ajax } from '../helpers/ajax';
import { Templates } from '../helpers/templates';
import { ExpandFaq } from './expand-faq';

export class LazyLoadSingle {
	constructor(elem, queryParams, templates, searchTerm, urlParams) {
		this.elem = elem;
		this.template = this.elem.dataset.template;
		this.templateFaq = this.elem.dataset.templateFaq;
		this.templateSearchEvent = this.elem.dataset.templateEvent;
		this.templateSearchContact = this.elem.dataset.templateContact;
		this.lazyload = this.elem.dataset.lazyBoard;
		this.endpoint = this.elem.dataset.endpoint;
		this.maxTextCharacters = this.elem.dataset.maxCharacters;
		this.searchTerm = searchTerm;
		this.counter = ElementHelpers.getParentByClass(this.elem, 'board-list').querySelector('.board-counter') || ElementHelpers.getParentByClass(this.elem, 'search').querySelector('[data-board-counter]');
		this.searchWordContainer = searchTerm && ElementHelpers.getParentByClass(this.elem, 'search').querySelector('.search-term') || null;
		this.templates = templates;
		this.cardTemplate = this.templates[this.template];
		this.faqTemplate = this.templates[this.templateFaq];
		this.eventSearchTemplate = this.templates[this.templateSearchEvent];
		this.contactSearchTemplate = this.templates[this.templateSearchContact];
		this.numberOfCards = parseInt(this.elem.dataset.lazyBoard);

		let overviewParent = ElementHelpers.getParentByClass(this.elem, 'block');
		this.noResults = overviewParent.querySelector('[data-lazy-no-results]') || undefined;

		this.pageObj = urlParams;
		this.initPage;

		this.params = queryParams;
		this.rendered = 0;
		this.page = 1;

		this.init();
	}

	init() {
		this.handlePaginationOnInit();

		if (this.isSearch()) {
			this.elem.dataset.searchResultsLoaded = false;
		}
		this.getData(true, true, this.params, false);
	}

	/**
	 * Handle initialized pagination if it's found in the pageObject
	 */
	handlePaginationOnInit() {
		let pagenumber;
		if (this.pageObj) {
			if (this.elem.dataset.eventsTimeline) {
				pagenumber = this.pageObj[`${this.elem.dataset.eventsTimeline}page`]
			} else {
				pagenumber = this.pageObj['page'];
			}
		}
		if (pagenumber) this.initPage = pagenumber[0];
	}

	/**
	 * Get the data from endpoint
	 * @param clearboard
	 * @param measure
	 */
	getData(clearboard, measure = true, params, initialLoader = false) {
		this.generateLoader(initialLoader);
		const separator = this.endpoint.indexOf('?') === -1 ? '?' : '&';
		Ajax.GET(this.generateUrl(separator, params)).then((results) => {
			if (this.getTimeline()) results = results[this.elem.dataset.eventsTimeline];
			this.updateBoard(results, clearboard);
			this.updateWindowLocation(params + this.urlPager());
			this.hideLoader();
			if (measure) this.handleAnalytics();
		}, () => {
			console.error('Error loading endpoint');
			return false;
		});
	}

	/**
	 * Generate URL for Ajax call to fetch
	 * @param separator
	 * @param params
	 * @returns {*}
	 */
	generateUrl(separator, params) {
		let url;
		if (this.initPage) {
			url = this.endpoint + this.setTimeline() + separator + params + `&pageSize=${this.getPageSize() * this.initPage}`;
			this.page = this.initPage;
			this.initPage = undefined;
		} else {
			url = this.endpoint + this.setTimeline() + separator + params + this.setPageSize() + this.pagination();
		}
		return url;
	}

	getTimeline() {
		return this.elem.dataset.eventsTimeline;
	}

	getPageSize() {
		return this.lazyload;
	}

	setTimeline() {
		return this.getTimeline() ? `/${this.getTimeline()}/` : '';
	}

	setPageSize() {
		return this.getPageSize() ? `&pageSize=${this.getPageSize()}` : '';
	}

	updateWindowLocation(string) {
		let location = window.location.search.split('?')[1] || '';
		let strs = location.split('&');

		let pagination = '';

		if (strs && this.getTimeline()) {
			for (let i = 0; i < strs.length; i++) {
				if (strs[i].indexOf('page') !== -1 && strs[i].indexOf(this.getTimeline()) === -1) {
					pagination = '&' + strs[i];
				}
			}
		}

		string = string + pagination;
		string = string.charAt(0) === '&' ? string.substring(1) : string;
		const newUrl = string ? window.location.href.split('?')[0] + '?' + string : window.location.href.split('?')[0];
		window.history.replaceState({}, document.title, newUrl);
	}

	createCard() {
		let template = document.createElement('div');
		template.className = 'card-holder__card';
		return template;
	}

	generateLoader(initial) {
		if (!this.elem.parentNode.querySelector('.loader-container')) {
			this.loader = document.createElement('div');
			this.loader.classList.add('loader-container');
			if (initial) {
				this.loader.classList.add('loader-container--top');
			}
			this.loader.innerHTML = '<div class="loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
			this.elem.parentNode.appendChild(this.loader);
		}
		if (this.noResults && this.noResults.dataset.lazyNoResults === 'visible') this.noResults.style.opacity = '0.3';
	}

	hideLoader() {
		ElementHelpers.removeElement(this.loader);
		if (this.noResults && this.noResults.dataset.lazyNoResults === 'visible') this.noResults.style.opacity = '1';
	}

	registerLazyload(total) {
		if (this.lazyload && this.rendered < total) {
			const container = document.createElement('div');
			container.classList.add('load-more-btn__wrapper');
			Templates.renderTemplate(
				this.getTimeline() === 'past' ? this.templates.loadMorePast : this.templates.loadMore,
				container,
				{options: ''}
			);
			this.elem.appendChild(container);
			const button = this.elem.querySelector('.button__load-more');
			button.addEventListener('click', (event) => {
				event.preventDefault();
				this.page++;
				Analytics.handleLinkClick(event.target);
				this.getData(false, true, this.params);
				ElementHelpers.removeElement(event.target.parentNode);
			});
		}
	}

	/**
	 * Update the board DOM element
	 * @param data
	 * @param clearBoard
	 */
	updateBoard(data, clearBoard = true) {
		let totalResults = this.getTotals(data) || 0;
		data = data.result;
		if (clearBoard) this.elem.innerHTML = '';
		this.activateSearchResults();
		this.updateCounter(totalResults);
		this.updateSearchTerm(this.searchTerm);
		this.toggleNoResults(totalResults);
		if (data) {
			this.total = data.length;
		} else {
			this.total = 0;
		}
		let delay = 0;

		for (let i = 0; i < this.total; i = i + 1) {
			this.createAndFillCard(data, i, delay);
		}

		this.numberOfCards = this.numberOfCards + this.rendered;
		this.registerLazyload(totalResults);
	}

	createAndFillCard(data, i, delay) {
		let card = this.createCard();
		let dataArray = this.modifyDataObject(data, i);
		this.renderCorrectTemplate(data, i, card, dataArray);
		let lastRenderedCard = card.querySelector('.card-holder__card--animated');
		Analytics.initTrackLinkClicks(card);
		this.elem.appendChild(card.children[0]);
		delay += 150;
		lastRenderedCard.style.animationDelay = delay + 'ms';
		this.rendered++;
	}

	/**
	 * Modify the data object, to rewrite date, add analytics, shorten text, etc.
	 * @param dataAnalyticsArray
	 * @param data
	 * @param i
	 * @returns {{templateData: []}}
	 */
	modifyDataObject(data, i) {
		let dataArray = {templateData: []};
		if (data[i].eventDate) data[i].eventDate = this.getDate(data[i].eventDate);
		if (data[i].publishDate) data[i].publishDate = this.getDate(data[i].publishDate);
		if (data[i].text && this.maxTextCharacters) data[i].text = this.shortenText(data[i].text);
		data[i].position = this.rendered + 1;
		dataArray.templateData = this.parseData(data[i]);
		return dataArray;
	}

	renderCorrectTemplate(data, i, card, dataArray) {
		if (data[i].faqDocument) {
			Templates.renderTemplate(this.faqTemplate, card, dataArray);
			let faqCard = card.querySelector('[data-faq-component]');
			new ExpandFaq(faqCard);
		} else if (data[i].eventDocument) {
			if (data[i].eventDocument.eventDate) data[i].eventDocument.eventDate = this.getDate(data[i].eventDocument.eventDate);
			Templates.renderTemplate(this.eventSearchTemplate, card, dataArray);
		} else if (data[i].personDocument) {
			data[i].personDocument.hasFunctionAndCompany = data[i].personDocument.functionTitle && data[i].personDocument.companyName;
			Templates.renderTemplate(this.contactSearchTemplate, card, dataArray);
		} else {
			Templates.renderTemplate(this.cardTemplate, card, dataArray);
		}
	}

	activateSearchResults() {
		const searchParent = ElementHelpers.getParentByClass(this.elem, 'search');
		if (this.isSearch() && !searchParent.classList.contains('search--active')) {
			searchParent.classList.add('search--active');
		}
	}

	getDate(timestamp) {
		const daysFullName = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
		const monthsFullName = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
		const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

		let a = new Date(timestamp);
		const date = a.getDate();
		const dayFullName = daysFullName[a.getDay()];
		const month = months[a.getMonth()];
		const monthFullName = monthsFullName[a.getMonth()];
		const years = a.getFullYear();

		const time = {
			day: date,
			dayFullName: dayFullName,
			month: month,
			monthFullName: monthFullName,
			year: years
		};
		return time;
	}

	shortenText(text) {
		if (text.length > this.maxTextCharacters) {
			const shortenedString = text.substring(0, this.maxTextCharacters);
			const lastSpace = shortenedString.lastIndexOf(' ');
			text = shortenedString.substring(0, lastSpace);
			text += ' (...)';
		}

		return text;
	}

	parseData(data) {
		if (data.analyticsData) {
			data.analyticsData = JSON.stringify(data.analyticsData);
			data.analyticsData = data.analyticsData.replace(/"/g, '&quot;');
		}
		return data;
	}

	updateCounter(amount) {
		this.counter.innerText = amount;
		if (this.isSearch()) {
			this.elem.dataset.searchResultsLoaded = true;
			const vacancyResultsElement = ElementHelpers.getParentByClass(this.elem, 'search').querySelector('[data-vacancy-results-loaded]') || '';
			if (vacancyResultsElement && vacancyResultsElement.dataset.vacancyResultsLoaded === 'true') {
				let vacancyCounter = ElementHelpers.getParentByClass(this.elem, 'search').querySelector('[data-vacancy-counter]').innerHTML;
				vacancyCounter = parseInt(vacancyCounter.match(/\d/g).join(''));
				this.counter.innerText = amount + vacancyCounter;
				this.elem.dataset.searchResultsLoaded = false;
			}
		}
	}

	updateSearchTerm(term) {
		if (term) {
			this.searchWordContainer.innerText = term;
		}
	}

	toggleNoResults(total) {
		if (this.noResults) {
			if (total <= 0) {
				this.noResults.dataset.lazyNoResults = 'visible';
				this.noResults.style.display = 'block';
			} else {
				this.noResults.dataset.lazyNoResults = 'hidden';
				this.noResults.style.display = 'none';
			}
		}
	}

	/**
	 * Get the totals from restpoint.
	 * Depends on scenario where there is an advisor and vacancies endpoint
	 * @param data
	 * @returns {*}
	 */
	getTotals(data) {
		const results = data.totalResults || data.totalresults;
		if (results === undefined) {
			return data.length;
		} else {
			return results;
		}
	}

	pagination() {
		return this.page > 1 ? `&page=${this.page}` : '';
	}

	urlPager() {
		return this.page > 1 ? `&${this.getTimeline() || ''}page=${this.page }` : '';
	}

	isSearch() {
		return this.searchTerm;
	}

	/**
	 * Emit an event to the Analytics class so data is collected
	 */
	handleAnalytics() {
		EventEmitter.emit('LazyloadBoard:getData');
	}
}

